/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_buyPage = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly item: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_item">;
            } | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedItemTrackingProvider_buyPage">;
    readonly " $refType": "BuySharedResultContainer_buyPage";
};
export type BuySharedResultContainer_buyPage$data = BuySharedResultContainer_buyPage;
export type BuySharedResultContainer_buyPage$key = {
    readonly " $data"?: BuySharedResultContainer_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedResultContainer_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedResultContainer_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "SharedItemTile_item",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "BuySharedItemTrackingProvider_buyPage",
      "args": null
    }
  ]
};
(node as any).hash = '8340c471d0398fac342b3a1286ba8b1b';
export default node;
